import React, { useState } from 'react';
import LocationIcon from '@mui/icons-material/FmdGood';
import { Card, CardContent } from '@mui/material';
import useTranslation from 'Hooks/useTranslation';
import { Circle } from '@mui/icons-material';
import { colors } from 'Constants/Colors';
import Chip from 'Components/Chip';
import Modal from 'Components/Modal';
import Alert from 'Components/Alert';
import MenuOptions from '../MenuOptions';
import Row from './Row';
import HorizontalDivider from './HorizontalDivider';
import ResetPasswordModal from '../ResetPasswordModal';
import { contentName, TextName, TextNormal, TextBold, OptionsButton } from './style';
import ChangeUserRole from '../ChangeUserRole';
import { usePermissionStore } from 'stores';

export default function CardUser({
  name = '',
  department = '',
  jobTitle = '',
  terminal = '',
  payrollNum = 0,
  entryDate = '',
  status = false,
  isAdmin = false,
  id = '',
  role = '',
}) {
  const [openModal, setOpenModal] = useState(false);
  const [openRoleModal, setOpenRoleModal] = useState(false);
  const [alertOpen, setAlertOpen] = useState();
  const [error, setError] = useState(false);
  const { t2 } = useTranslation('EmployeeAssess');
  const menuOptions = [t2('ChangePassword')];

  // Permisos del usuario
  const permissions = usePermissionStore(state => state.permissions);

  // Permiso para mostrar cambiar tipo de usuario
  const canChangeRole = permissions.find(p => p.key === 'employee.*' && p.assigned === true);

  const handlePasswordModal = () => {
    setOpenModal(true);
  };

  const handleChangeRole = () => {
    setOpenRoleModal(true);
  };

  const functions = [handlePasswordModal, handleChangeRole];

  // Si es admin se agrega la opción de cambiar tipo de usuario
  if (isAdmin || canChangeRole) {
    menuOptions.push(t2('change_user_type'));
    functions.push(handleChangeRole);
  }

  return (
    <Card
      sx={{
        minWidth: 350,
        position: 'relative',
        padding: '1rem',
        height: 'max-content',
      }}
    >
      <OptionsButton>
        <MenuOptions options={menuOptions} functions={functions} />
      </OptionsButton>
      <CardContent style={contentName}>
        <TextName>{name}</TextName>
        <HorizontalDivider>
          {department}
          {jobTitle}
        </HorizontalDivider>
        <Chip>
          <LocationIcon style={{ color: colors.GREEN }} />
          {terminal}
        </Chip>
      </CardContent>
      <Row>
        <TextNormal>{t2('EmployeeNumber')}</TextNormal>
        <TextBold>{payrollNum}</TextBold>
      </Row>
      <Row>
        <TextNormal>{t2('EntryDate')}</TextNormal>
        <TextBold>{entryDate}</TextBold>
      </Row>
      <Row>
        <TextNormal>{t2('UserType')}</TextNormal>
        <TextBold>{role}</TextBold>
      </Row>
      <Row>
        <TextNormal>{t2('Status')}</TextNormal>
        <Chip>
          <Circle style={{ color: status ? colors.GREEN : colors.RED }} />
          <TextBold>{status ? t2('Active') : t2('Inactive')}</TextBold>
        </Chip>
      </Row>
      <Modal
        open={openModal}
        setOpen={setOpenModal}
        Children={
          <ResetPasswordModal
            isAdmin={isAdmin}
            t2={t2}
            setOpen={setOpenModal}
            setAlertOpen={setAlertOpen}
            setError={setError}
            id={id}
          />
        }
        size="xs"
      />
      <Modal
        open={openRoleModal}
        setOpen={setOpenRoleModal}
        Children={<ChangeUserRole t2={t2} setOpen={setOpenRoleModal} id={id} oldRole={role} />}
        size="xs"
      />
      <Alert
        message={!error ? t2('AlertSuccessChangePassword') : t2('AlertErrorChangePassword')}
        open={alertOpen}
        setOpen={setAlertOpen}
        error={error}
      />
    </Card>
  );
}
